$.ajaxSetup({
    headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    }
});

$(function() {

    $('#mysearch').hide();

    $('#search-icon, .search-icon').click(function() {
        $('#mysearch').show();
        $('#search-icon').hide();
        $('.overlay').show();
        $('#mysearch').val('');
        lastSearchText = '';
        $('.nav-container').hide();
        $('#mysearch').focus();
        $('.search-menu').hide();

    });

    $('#mysearch').focusout(function() {
        setTimeout(function(){
            $('#mysearch').val('');
            $('#mysearch').hide();
            $('.overlay').hide();
            $('.nav-container').show();
            $('#search-icon').show();
            $('.search-menu').hide();
        }, 250);
    });

    const SEARCH_DELAY = 700;   // ms nach der letzten Eingabe
    const SEARCH_MIN_LENGTH = 3;
    let timeoutId;
    let lastSearchText = '';

    function doSearch(searchText) {
        clearTimeout(timeoutId);

        if (searchText.length < SEARCH_MIN_LENGTH) {
            return;
        }

        timeoutId = setTimeout(function () {
            // Gleicher Begriff wie zuletzt (z.B. change-Event nach keyup): kein neuer Request
            if (searchText === lastSearchText) {
                return;
            }
            lastSearchText = searchText;

            let results = '';

            $.ajax({
                type: "POST",
                url: '/api/search',
                data: {search: searchText},
                success: function (result) {

                    if (result.found.length > 0) {
                        for (let i = 0; i < result.found.length && i < 3; i++) {
                            results += '<li>';
                            results += '<a href="/' + result.found[i].full_slug + '">';
                            results += '<img class="searchimg" src="' + result.found[i].image + '" />';
                            results += '<span class="text-secondary">' + result.found[i].headline + '</span>';
                            results += '<div class="menuright"><img src="https://a.storyblok.com/f/303563/6x11/9b0c85fa48/arrow-secondary-right.svg" alt="Pfeil rechts"></div>';
                            results += '</a>';
                            results += '</li>';
                        }
                    } else {
                        results += '<li>';
                        results += '<span class="notfound">Keine Ergebnisse gefunden</span>';
                        results += '</li>';
                    }
                    $('ul.search-menu').html(results);

                    if ($('#mysearch').val().length > 0) {
                        $('.search-menu').show();
                    } else {
                        $('.search-menu').hide();
                    }
                },
                error: function (result) {
                    console.error(result);
                }
            });
        }, SEARCH_DELAY);
    }


    $('#mysearch').keyup(function() {
        doSearch($(this).val());
    });

    $('#mysearch').change(function() {
        $(this).keyup();
    });

});
